import { PropsWithChildren } from "react";
import { ReactComponent as LeftArrowIcon } from "../../../resources/icons/Property 1=back.svg";

interface HeaderProps extends PropsWithChildren {
    onBack: () => void;
}

export function HeaderWithBack({ onBack, children }: HeaderProps) {
    return (
        <div className="flex flex-row mb-36">
            <div
                className="w-32 h-32 bg-secondary-blue-light rounded-full flex justify-center items-center cursor-pointer transition-colors hover:bg-primary-identity-Blue"
                onClick={onBack}
            >
                <LeftArrowIcon className="svg-primary-blue svg-white-hover" />
            </div>
            <div className="flex-1 pl-24">{children}</div>
        </div>
    );
}
